<ng-container *transloco="let t;">

  <h2>{{ t('common.labels.jobinformation') }}</h2>

  <div class="p-grid">
    <div class="p-col-12">
      <app-form-control [cid]="'hasjob'" [control]="form.get('jobinformation.hasjob')" [type]="'checkbox'" [label]="t('orderform.checkbox_hasjob')" [noMargin]="true"></app-form-control>
    </div>
    <div class="p-col-4">
      <app-form-control [cid]="'jobtitle'" [control]="form.get('jobinformation.jobtitle')" [type]="'input'" [label]="t('common.labels.jobtitle')"></app-form-control>
    </div>
    <div class="p-col-4">
      <app-form-control [cid]="'candidatetype'" [control]="form.get('jobinformation.settings.candidatetype')" [type]="'select'" [options]="options?.candidatetype" [label]="t('common.labels.candidatetype')"></app-form-control>
    </div>
  </div>
  <div class="p-grid">
    <div class="p-col-4">
      <app-form-control [cid]="'recruiter'" [control]="form.get('jobinformation.recruiter')" [type]="'input'" [label]="t('common.labels.recruiter')"></app-form-control>
    </div>
    <div class="p-col-4">
      <app-form-control [cid]="'businessunit'" [control]="form.get('jobinformation.settings.businessunit')" [type]="'group'" [filterBy]="'value.name'" [options]="options?.businessunits" [label]="t('common.labels.businessunit')"></app-form-control>
    </div>
  </div>

</ng-container>
